import type { FaireProductEntity } from "../../entity_types/product";

export const p_mgzz9ym525: FaireProductEntity = {
  token: "p_mgzz9ym525",
  type: "product",
  name: "Women’s Long Open Front Knit Cardigan",
  brandToken: "b_3eopd3scey",
  brandName: "ACCITY",
  imageUrl:
    "https://cdn.faire.com/fastly/28ab7e186b7fb6914006d0ae21003ac432e11e341f8a5ff111f5b850848da2b1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/989af1057bf7c928999dcd7c2f0202f1b28e241bd29955ed4ad7795aa91f13bf.jpeg",
    "https://cdn.faire.com/fastly/1d2c56748da601dcbecca33656dadffbff210bffe5aed100393abe5fd4347f11.jpeg",
    "https://cdn.faire.com/fastly/1d6b651bf5a96e83729bd3b5846b0343483671cf5cf65a74fd38ece57ef552c4.jpeg",
    "https://cdn.faire.com/fastly/3fc726613bd6dab3af98f83038d3f6f60d771cc858b5f08c7597685b0c955a9f.png",
    "https://cdn.faire.com/fastly/4353ff85b4eb07db0fed3136ddae6395b229b6deac14a3ca94d700e97470869f.jpeg",
    "https://cdn.faire.com/fastly/c3bd3bf6a805498c04f4b21a7295fc609518c660868158d2d534f3f4d568a2c8.jpeg",
    "https://cdn.faire.com/fastly/037b707ee5e6f9c6e85662513882f634aeb638df4019421e3a56b70799df0efa.jpeg",
    "https://cdn.faire.com/fastly/858346732236fc7b05d1a82ebe875a95f5dd7f3d5facef758ac36fa98b9253c3.jpeg",
    "https://cdn.faire.com/fastly/17c1d61b3395c4d823e1a466ad8a89fb27fc3b753699b69b7954869dac4e98f0.jpeg",
    "https://cdn.faire.com/fastly/329feb0e63ebea9508f5d99a1dbfe21bb5a879bdc25a6c5a09acc718a99edf5a.jpeg",
    "https://cdn.faire.com/fastly/8812659535e3042f14b0b95c07ca65fb5112934fcfbdc225f422c78f5aabec57.jpeg",
    "https://cdn.faire.com/fastly/de8ea8e300091bca54126329d2cc4d9a036d496f8892b354fa7b556e733df38d.jpeg",
    "https://cdn.faire.com/fastly/4172892b1adfc38ddf09f777e6e67cfdc83d26e7ba2751a98125f569d3e6227c.jpeg",
    "https://cdn.faire.com/fastly/940b536e5026fbd3f86cc04442458eb051e57716c30f39feef526267b60340be.jpeg",
  ],
  priceDollars: 13,
  description:
    "97%POLYESTER,3%SPANDEX\nSIZE  S / M / L / XL\nMADE IN CHINA\n\nWOMEN BLAZER, CROCHET CARDIGAN, CABLE KNIT SWEATER, RUFFLE DRESS, EYELET BLOUSE, PUFF SLEEVE TOP, DENIM SKIRTS, DENIM SHORTS, RIPPED JAENS, RIPPED JEANS, MAXI SKIRT, JUMPSUIT, CROP TOP, SHORT SLEEVE, SHOLESALE SHIRTS, PLAIS SHIRT, WOMEN SHORTS, PANTS, BOHEMIAN, BOHO, WINTER BLOUSE, WINTER SHIRT, WESTERN, BEST SELLING, PROMOTION, TRENDING, NEW PRODUCTS, ACTIVEWEAR, COSTUMES, UNIFORMS, JUMPSUITS, LOUNGEWEAR, SLEEPWEAR NIGHTWEAR, SWEATSHIRTS, HOODIES, TANK TOPS, CHRISTMAS, HOT SELLING ",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:07.706Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
